import { ACCESS_URL } from "../../context/paths";
import { captureClientError } from "../../utils/captureClientError";

const NETWORK_ERROR = { message: "Erro de comunicação com o servidor", type: "error" };

const request = async (op, url, token, { method = "GET", body } = {}) => {
    try {
        const response = await fetch(url, {
            method,
            headers: {
                "Content-Type": "application/json",
                "authorization": `Bearer ${token}`
            },
            ...(body ? { body: JSON.stringify(body) } : {})
        });
        return await response.json();
    } catch (error) {
        captureClientError(error, { area: "access", op });
        return NETWORK_ERROR;
    }
};

export const getStaff = (token) =>
    request("getStaff", `${ACCESS_URL}/staff`, token);

export const searchUsers = (token, q) =>
    request("searchUsers", `${ACCESS_URL}/users/search?q=${encodeURIComponent(q)}`, token);

export const updateRoles = (token, userId, { admin, master }) =>
    request("updateRoles", `${ACCESS_URL}/roles/${userId}`, token, { method: "PUT", body: { admin, master } });

export const getGroups = (token) =>
    request("getGroups", `${ACCESS_URL}/groups`, token);

export const createGroup = (token, { name, description }) =>
    request("createGroup", `${ACCESS_URL}/groups`, token, { method: "POST", body: { name, description } });

export const updateGroup = (token, groupId, body) =>
    request("updateGroup", `${ACCESS_URL}/groups/${groupId}`, token, { method: "PUT", body });

export const deleteGroup = (token, groupId) =>
    request("deleteGroup", `${ACCESS_URL}/groups/${groupId}`, token, { method: "DELETE" });
